import { EditorState } from "@codemirror/state"
import { EditorView, basicSetup } from "codemirror";
import { javascript } from "@codemirror/lang-javascript";
import { css } from "@codemirror/lang-css";

export default function () {
    var textArea = document.getElementById('CodeValueEditor');

    if (!textArea)
        return;

    let type = textArea.dataset.editorType;

    if (type == 'raw')
        return;

    let lang = (type == 'script' ? javascript() : css());
    let view = new EditorView({
        doc: textArea.value, extensions: [basicSetup, lang, EditorView.updateListener.of(function (e) {
            textArea.value = e.state.doc.toString();
        })]
    });

    textArea.parentNode.insertBefore(view.dom, textArea)
    textArea.style.display = "none"

    const currentNumOfLines = view.state.doc.lines;
    const currentStr = view.state.doc.toString();
    const minNumOfLines = 10;

    if (currentNumOfLines >= minNumOfLines) {
        return;
    }

    const lines = minNumOfLines - currentNumOfLines;
    const appendLines = "\n".repeat(lines);

    view.dispatch({
        changes: { from: currentStr.length, insert: appendLines }
    });
}